/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

// Import Redux
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  addNewLabelPvt,
  removeNewLabelPvt,
} from "../../../redux/features/privatetransactions/privatetransactions.js";
import {
  approvePrivateTxn,
  getAllPrivateTransactions,
  rejectPrivateTxn,
} from "../../../redux/features/privatetransactions/privatetransactions.js";
import { getOwnerAccountIFSCDetails } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { beneCategories } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";
import { getOwnerAccBalance } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";

// Import utils
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider.js";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount.js";
import ICONS from "../../../assets/Icons/index.js";
import formatDateViewAll from "../../../utils/formatDateViewAll.js";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PrivateDetailPopup from "./PrivateDetailPopup/index.jsx";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import CommonAccountApprovalCard from "../../../components/_utils/CommonAccountApprovalCard/index.jsx";
// Import Components
import Loader from "../../../components/Loader/Index.jsx";
import useServiceChecker from "../../../components/ServiceChecker";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";

const PrivateTxnSingleApproval = ({ typepop }) => {
  const filterRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const [ensureAll] = useServiceChecker();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [pageSize, setPageSize] = useState(
    GlobalConfiguration?.searchMaxLength,
  );
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration?.lengthCheckOne,
  );
  const [active, setActive] = useState("");
  const [selectedTxnForLabel, setSelectedTxnForLabel] = useState(null);
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [currentFileStatus] = useState("require approval");
  const [currentCategory, setCurrentCategory] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");

  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);

  const [openDeclinePopup, setOpenDeclinePopup] = useState(false);
  const [isLoadingDecline, setIsLoadingDecline] = useState(false);
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);

  const [declineReason, setDeclineReason] = useState("");
  const [declineId, setDeclineId] = useState("");
  const [moreDetailId, setMoreDetailId] = useState("");

  const [inputData, setInputData] = useState([]);

  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labelId, setLabelId] = useState("");
  const [labels, setLabels] = useState([]);
  const popupLabels = React.useMemo(() => {
    if (!Array.isArray(labels)) return [];
    return labels.filter((label) => !/[A-Z]/.test(label || ""));
  }, [labels]);
  const [phantomMarker, setPhantomMarker] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [moreDetailOpen, setMoreDetailOpen] = useState("");
  const [approveRejectBtnClicked, setApproveRejectbtnClicked] = useState({});
  const [privateTxnData, setPrivateTxnData] = useState({
    transaction_requests: null,
    total_count: GlobalConfiguration?.lengthCheckZero,
    title: {
      records: GlobalConfiguration?.lengthCheckZero,
      total_pages: GlobalConfiguration?.lengthCheckZero,
      page_item_count: pageSize,
    },
  });
  const [allPrivateTxnDataLoading, setAllPrivateTxnDataLoading] =
    useState(true);

  const dropdownOptions = PaginationConfiguration?.paginationOptions;

  const DeclinedRed = ICONS.REJECTED_RED;
  const PendingIcons = ICONS.PENDING;
  const FailedToAction = ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE;

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const handleDeclinePopup = (id) => {
    setDeclineId(id);
    setOpenDeclinePopup(true);
  };

  const handleApproveTransaction = async (id) => {
    CommonToast({
      text: "Approving transaction.",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
    try {
      setIsLoadingApprove(true);

      const data = await dispatch(approvePrivateTxn({ id: [id] })).unwrap();

      await delay(GlobalConfiguration?.delayTime);

      if (data?.status) {
        if (data?.private_transaction?.status === "pending") {
          setPrivateTxnData((prev) => ({
            ...prev,
            transaction_requests: prev?.transaction_requests?.map((item) => {
              if (item?.private_transaction_id === id) {
                return {
                  ...item,
                  request_status: "pendingOne",
                };
              }

              return item;
            }),
          }));
        } else {
          setPrivateTxnData((prev) => ({
            ...prev,
            transaction_requests: prev?.transaction_requests?.filter(
              (item) => item?.private_transaction_id !== id,
            ),
            title: {
              ...prev.title,
              records: prev.title.records - 1,
            },
            total_count: prev?.total_count - 1,
          }));
        }

        CommonToast({
          text: "Transaction approved successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (error) {
      await delay(GlobalConfiguration?.delayTime);
      toast.dismiss();

      setPrivateTxnData((prev) => ({
        ...prev,
        transaction_requests: prev?.transaction_requests?.map((item) =>
          item?.private_transaction_id === id
            ? {
                ...item,
                request_status: "error",
              }
            : item,
        ),
      }));
      return error;
    } finally {
      setIsLoadingApprove(false);
      setApproveRejectbtnClicked((p) => {
        return { ...p, [id]: "none" };
      });
    }
  };

  const handleClearParams = (e) => {
    e?.stopPropagation();
    setLabelSearchText("");
    setCurrentCategory("");

    setShowSearchBar(false);
    setSearchUserTextDebounce("");
  };

  const handleDeclinedDetails = async (id) => {
    CommonToast({
      text: "Rejecting transaction.",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
    try {
      setIsLoadingDecline(true);
      await delay(GlobalConfiguration?.delayTime);

      const data = await dispatch(
        rejectPrivateTxn({
          id: [id],
          reason: declineReason,
        }),
      ).unwrap();

      if (data?.status) {
        setPrivateTxnData((prev) => ({
          ...prev,
          transaction_requests: prev?.transaction_requests?.map((item) =>
            item?.private_transaction_id === id
              ? {
                  ...item,
                  request_status: "rejected",
                  reason: declineReason,
                }
              : item,
          ),
        }));
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (error) {
      await delay(GlobalConfiguration?.delayTime);
      toast.dismiss();
      // CommonToast({
      //   text: "",
      //   icon: ICONS?.ERROR_WHITE_CIRCLE,
      //   variant: "var(--error)",
      //   btnProps: {
      //     isDisabled: false,
      //     enabledTextColor: "var(--text-primary)",
      //     enabledBgColor: "var(--primary-bg)",
      //   },
      // });

      setPrivateTxnData((prev) => ({
        ...prev,
        transaction_requests: prev?.transaction_requests?.map((item) =>
          item?.private_transaction_id === id
            ? {
                ...item,
                request_status: "error",
              }
            : item,
        ),
      }));
      return error;
    } finally {
      setIsLoadingDecline(false);
      setOpenDeclinePopup(false);
      setDeclineId("");
      setDeclineReason("");
    }
  };

  const handleInputChange = (event) => {
    let value = event.target.value;

    // 1. Allow only alphanumeric + space
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");

    // 2. Remove leading spaces
    value = value.replace(/^\s+/, "");

    // 3. Allow only one space between words
    value = value.replace(/\s{2,}/g, " ");

    // 4. Limit to 150 characters
    value = value.slice(
      GlobalConfiguration?.lengthCheckZero,
      GlobalConfiguration?.inputMaxLength,
    );

    setDeclineReason(value);
  };

  const convertDate = (timestampInSeconds) => {
    if (!timestampInSeconds) return "";

    const date = new Date(
      Number(timestampInSeconds) * GlobalConfiguration.delayTime,
    );

    const day = String(date.getDate()).padStart(
      GlobalConfiguration.lengthCheckTwo,
      "0",
    );
    const month = String(date.getMonth() + 1).padStart(
      GlobalConfiguration.lengthCheckTwo,
      "0",
    );
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  // Initial data with status filter and total_amount filter
  const getPrivateTxnData = async () => {
    try {
      setAllPrivateTxnDataLoading(true);

      const queryParams = {
        page_no: currentPage,
        page_size: pageSize,
      };

      if (currentFileStatus?.length) {
        queryParams.status = currentFileStatus;
      } else {
        queryParams.status = currentFileStatus;
      }

      if (currentCategory) {
        queryParams.category = currentCategory;
      }

      if (
        startDateFilter &&
        endDateFilter &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.from_date = convertDate(startDateFilter);
        queryParams.to_date = convertDate(endDateFilter);
      }

      if (LabelSearchText?.length !== GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }

      const response = await dispatch(getAllPrivateTransactions(queryParams));
      const rawData = response?.payload || {};

      setPrivateTxnData(rawData);
      setLabels(rawData?.summary?.available_labels ?? []);
    } catch (error) {
      setPrivateTxnData({});
    } finally {
      setAllPrivateTxnDataLoading(false);
    }
  };
  useEffect(() => {
    if (labelActionDispatchedRef.current) {
      getPrivateTxnData();
      labelActionDispatchedRef.current = false;
    }
  }, [phantomMarker]);

  const onMount = () => {
    getPrivateTxnData();
  };

  const handlePagination = (page) => setCurrentPage(page);

  const handleSelect = (value) => {
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const displayDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / GlobalConfiguration.delayTime,
    );

    return timestamp;
  };

  const handleFilterDateRange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(displayDate(start));
      setEndDateFilter(displayDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  function capitalizeText(str) {
    if (!str) return str;
    const lower = str.split("_").join(" ").toLowerCase();
    const firstChar = lower
      .charAt(GlobalConfiguration.lengthCheckZero)
      .toUpperCase();
    return firstChar + lower.slice(GlobalConfiguration.lengthCheckOne);
  }
  //Refresh Owner Account Balance
  const handleRefreshBalance = async (id) => {
    if (!id) return;

    try {
      toast.dismiss();

      CommonToast({
        text: "Refreshing balance",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });

      const response = await dispatch(getOwnerAccBalance(id));

      if (response?.payload?.status === true) {
        const newBalance =
          response?.payload?.owner_accounts[GlobalConfiguration.lengthCheckZero]
            ?.owner_account_balance;
        const updatedTime =
          response?.payload?.owner_accounts[GlobalConfiguration.lengthCheckZero]
            ?.owner_account_balance_last_fetched_at_in_words;

        setPrivateTxnData((prevData) => ({
          ...prevData,
          transaction_requests: prevData?.transaction_requests?.map((txn) => {
            if (txn?.owner_account_details?.owner_account_id === id) {
              return {
                ...txn,
                owner_account_details: {
                  ...txn.owner_account_details,
                  owner_account_balance: newBalance,
                  owner_account_balance_last_fetched_at_in_words: updatedTime,
                },
              };
            }
            return txn;
          }),
        }));
        toast.dismiss();
        CommonToast({
          text: "Balance updated",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        toast.dismiss();

        CommonToast({
          text:
            response?.payload?.response?.data?.errors?.base[
              GlobalConfiguration.lengthCheckZero
            ] || "Update failed",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (error) {
      return error;
    }
  };

  const handleLabelPopupClose = () => {
    setIsLabelPopupOpen(false);
    setLabelId("");
    setSelectedTxnForLabel(null);
    setPhantomMarker((x) => x + GlobalConfiguration.lengthCheckOne);
  };

  const openMoreDetailPopup = () => {
    setMoreDetailOpen(true);
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    if (!selectedTxnForLabel) return false;

    setAllPrivateTxnDataLoading(true);

    const recordIds = [labelId];

    const res = await dispatch(
      addNewLabelPvt({ record_ids: recordIds, labels: labelsToAssign }),
    );

    if (addNewLabelPvt.fulfilled.match(res)) {
      setPrivateTxnData((prev) => ({
        ...prev,
        transaction_requests: prev?.transaction_requests?.map((item) => {
          if (item?.request_reference_id === labelId) {
            const currentLabels = item?.labels || [];
            const newLabels = [
              ...new Set([...currentLabels, ...labelsToAssign]),
            ];
            return { ...item, labels: newLabels };
          }
          return item;
        }),
      }));

      setSelectedTxnForLabel((prev) => {
        if (!prev) return prev;
        const currentLabels = prev?.labels || [];
        const newLabels = [...new Set([...currentLabels, ...labelsToAssign])];
        return { ...prev, labels: newLabels };
      });

      labelActionDispatchedRef.current = true;
    } else if (addNewLabelPvt.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setAllPrivateTxnDataLoading(false);
    return addNewLabelPvt.fulfilled.match(res);
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    if (!selectedTxnForLabel) return false;

    setAllPrivateTxnDataLoading(true);

    const recordIds = [labelId];

    const res = await dispatch(
      removeNewLabelPvt({ record_ids: recordIds, labels: labelsToUnassign }),
    );

    if (removeNewLabelPvt.fulfilled.match(res)) {
      setPrivateTxnData((prev) => ({
        ...prev,
        transaction_requests: prev?.transaction_requests?.map((item) => {
          if (item?.request_reference_id === labelId) {
            const currentLabels = item?.labels || [];
            const newLabels = currentLabels.filter(
              (lbl) => !labelsToUnassign.includes(lbl),
            );
            return { ...item, labels: newLabels };
          }
          return item;
        }),
      }));

      setSelectedTxnForLabel((prev) => {
        if (!prev) return prev;
        const currentLabels = prev?.labels || [];
        const newLabels = currentLabels.filter(
          (lbl) => !labelsToUnassign.includes(lbl),
        );
        return { ...prev, labels: newLabels };
      });

      labelActionDispatchedRef.current = true;
    } else if (removeNewLabelPvt.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllPrivateTxnDataLoading(false);
    if (removeNewLabelPvt?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());

    return () => dispatch(disableSwitcher());
  }, []);

  useEffect(() => {
    if (!isLabelPopupOpen) return;
    const availableLabels = sessionStorage?.getItem("AvailableLabelsPvt");
    const parsedLabels = JSON?.parse(availableLabels) || [];
    setLabels(parsedLabels);
  }, [isLabelPopupOpen]);

  useEffect(() => {
    onMount();
  }, [
    currentPage,
    pageSize,
    currentFileStatus,
    startDateFilter,
    endDateFilter,
    currentCategory,
    phantomMarker,
    LabelSearchText,
    markerData,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      let response;
      let data = [];

      try {
        switch (active) {
          case "IFSC code":
            response = await dispatch(
              getOwnerAccountIFSCDetails({
                search_string: searchUserTextDebounce,
                page_no: GlobalConfiguration.lengthCheckOne,
                page_size: GlobalConfiguration.filterResults,
              }),
            );

            data =
              response.payload.ifsc_details?.map((item) => ({
                id: item?.ifsc,
                IFSC_code: item?.ifsc,
              })) || [];

            break;

          case "Category":
            response = await dispatch(
              beneCategories({ search_string: searchUserTextDebounce }),
            );
            data =
              response?.payload?.categories?.map((item) => ({
                id: item?.name,
                Category_name: item?.name,
              })) || [];
            break;
          case "Labels":
            data = labels
              ?.filter((itm) => {
                if (itm.includes(searchUserTextDebounce)) return true;
                else return false;
              })
              ?.map((val) => {
                return { id: val, Label: val };
              });
            setInputData(data);
            break;

          default:
            data = [];
            break;
        }
      } catch (error) {
        data = [];
      } finally {
        setInputData(data);
        // setLoadingData(false);
      }
    };
    fetchData();
  }, [active]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {moreDetailOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <PrivateDetailPopup
            closePrivateDetailModal={() => {
              setMoreDetailOpen(false);
            }}
            private_id={moreDetailId}
            type={"private_detail_modal"}
            setPrivateTxnData={setPrivateTxnData}
          />
        </div>
      )}
      {openDeclinePopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Reject transaction"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the transaction."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteText="The reason must consist of at least 10 characters."
            noteColor="text-secondary"
            inputPlaceholder="Reason"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnTwoInActiveVariantNeeded={true}
            // btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!isLoadingDecline) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            // End of Input Field Props
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!isLoadingDecline) {
                setOpenDeclinePopup(false);
                setDeclineReason("");
                setApproveRejectbtnClicked((p) => {
                  return { ...p, [declineId]: "none" };
                });
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              // setbtnClicked((prev) => ({
              //   ...prev,
              //   [viewInternalTxnDetails[0]?.id]:
              //     "Reject",
              // }));
              handleDeclinedDetails(declineId);
              setApproveRejectbtnClicked((p) => {
                return { ...p, [declineId]: "none" };
              });
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              declineReason.length < GlobalConfiguration.panLength ||
              isLoadingDecline
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={isLoadingDecline ? true : false}
            btnTwoIsLoading={isLoadingDecline ? true : false}
            btnTwoHoverOption="black"
            btnOneInActiveVariantNeeded={true}
          />
        </div>
      )}
      {isLabelPopupOpen && (
        <div
          onClick={handleLabelPopupClose}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex"
          max-zindex
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleLabelPopupClose}
            closeisDisabled={false}
            labels={popupLabels}
            setLabels={setLabels}
            LabelAccounts={labelId}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={
              selectedTxnForLabel
                ? [
                    {
                      ...selectedTxnForLabel,
                      id: selectedTxnForLabel?.request_reference_id,
                      labels: selectedTxnForLabel?.labels || [],
                    },
                  ]
                : []
            }
            onClose={handleLabelPopupClose}
            loading={allPrivateTxnDataLoading}
            setLoading={setAllPrivateTxnDataLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {/* Pagination component */}

      {/* --------------------------- */}
      <div
        className={`flex flex-col items-center relative w-width-full h-full-height overflow-hidden`}
      >
        <div
          className={`bene_div_container Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act ${typepop === "popup" ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
        >
          <div className="Qmd:min-h-navbar-breadcrumb-height bg-primary-nav"></div>
          <TopNavComponent
            topNavCtaBtn1Needed={false}
            handleBack={
              typepop === "popup"
                ? undefined
                : () => {
                    navigate(GlobalConfiguration.lengthCheckNegativeOne);
                  }
            }
            filteredSearchProps={{
              isSearchDisabled: allPrivateTxnDataLoading,
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              // isSearchDisabled: isSidebarOpen || loading,
              onSearchInput: (val) => handleSearch(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search private transactions",
              filterPlaceholder: "transaction details",
              filterItems: [
                {
                  name: "Category",
                  short_name: "Cat",
                  valueType: "string",
                  isMulti: false,
                  value: currentCategory,
                  setValue: setCurrentCategory,
                  isDropdown: true,
                  isDisabled: allPrivateTxnDataLoading ? true : false,
                },

                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: setLabelSearchText,
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: allPrivateTxnDataLoading,
                },
              ],
              filters: [
                {
                  name: "File statuses",
                  filterType: "dropdown",
                  variant: "single",
                  isSearch: false,
                  searchPlaceholder: "Search",
                  isDisabled: true,
                  value: "Require Approval",
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(startDateFilter * 1000)
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(endDateFilter * 1000)
                    : endDateFilter,
                  handleChange: (date) => handleFilterDateRange(date),
                },
              ],

              inputData: inputData,
              active: active,
              setActive: setActive,

              isShowSortBy: false,
              isShowFilter: false,
            }}
          />
        </div>
        <div
          className={`flex flex-col items-center w-width-full h-height-full bg-primary-bg   mb-[var(--pagination-height)] ${
            showInnerSearchBar
              ? "overflow-y-hidden  cursor-pointer-none pointer-events-none"
              : "overflow-auto"
          } `}
        >
          {allPrivateTxnDataLoading ? (
            <div className={`m-auto justify-center items-center flex  `}>
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              <Loader />
            </div>
          ) : privateTxnData?.transaction_requests &&
            privateTxnData?.transaction_requests?.length >
              GlobalConfiguration.lengthCheckZero &&
            !allPrivateTxnDataLoading ? (
            <div
              className={`scroll flex flex-col  w-width-full items-center justify-center`}
              ref={filterRef}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              <div className="fixed w-full bottom-bottom-base bg-primary-nav z-z-index-tooltip">
                <div>
                  {showInnerSearchBar && (
                    <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
                  )}
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={pageSize}
                    data={privateTxnData}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={(e) => {}}
                  />
                </div>
              </div>
              <div className="scroll flex flex-col items-center justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base pb-padding-xl gap-gap-md">
                {privateTxnData?.transaction_requests?.map((txn, index) => {
                  return (
                    <div
                      key={txn?.id}
                      className={`w-width-full ${index === GlobalConfiguration.lengthCheckZero ? "mt-margin-md" : ""}`}
                    >
                      <CommonAccountApprovalCard
                        overrideAutoLoader
                        whichBtnClicked={
                          approveRejectBtnClicked?.[
                            txn?.private_transaction_id
                          ] ?? "none"
                        }
                        entries={[
                          [
                            {
                              type: "textSubtext",
                              text:
                                "INR " +
                                FormatAmount({
                                  price: txn?.total_amount,
                                }),
                              textColor: "settled",
                              subText: "Total transaction amount",
                              isBold: true,
                            },
                            {
                              type: "accountNumber",
                              text: txn?.owner_account_details
                                ?.owner_account_bank_acc_no,
                              subText: "Source account",
                              ifsc: txn?.owner_account_details
                                ?.owner_account_ifsc_code,
                            },
                            {
                              type: "amount",
                              text:
                                txn?.owner_account_details
                                  ?.owner_account_balance ||
                                GlobalConfiguration.lengthCheckZero,
                              subText: txn?.owner_account_details
                                ?.owner_account_balance_last_fetched_at_in_words
                                ? `Balance - updated ${txn?.owner_account_details?.owner_account_balance_last_fetched_at_in_words}`
                                : "Balance",
                              refreshOnClick: () =>
                                handleRefreshBalance(
                                  txn?.owner_account_details?.owner_account_id,
                                ),
                            },
                          ],
                          [
                            {
                              type: "textSubtextX2",
                              text: txn?.category,
                              subText: "Category selected",

                              text1: txn?.created_at
                                ? formatDateViewAll(txn?.created_at, true, true)
                                : "N/A",

                              subText1: "Created on",
                            },
                            {
                              type: "textSubtext",
                              text: txn?.total_beneficiary_account_count,
                              subText: "Total beneficiary accounts",
                            },
                            {
                              type: "cta",
                              text:
                                txn?.labels?.join(", ") || "No labels assigned",
                              subText: "Label",
                              onClick: (e) => {
                                setLabelId(txn?.request_reference_id);
                                setSelectedTxnForLabel(txn);
                                setIsLabelPopupOpen(true);
                              },
                            },
                          ],
                          [
                            {
                              type: "textSubtext",
                              text: capitalizeText("Require approval"),
                              subText: "File status",
                              textColor: "var(--pending)",
                              isBold: true,
                            },
                          ],
                        ]}
                        cardState={
                          txn?.request_status === "rejected"
                            ? "double"
                            : txn?.request_status === "error" ||
                                txn?.request_status === "pendingOne"
                              ? "single"
                              : "default"
                        }
                        ctaBtn1Text={"More details"}
                        ctaBtn1OnClick={
                          () => {
                            setMoreDetailId(txn?.request_reference_id);
                            openMoreDetailPopup();
                          }
                          // alert(
                          //   `open pvt txn id: ${txn?.id}`,
                          // )
                        } // Open Popup with Private Txn Detail Page
                        approveBtnText="Approve transaction"
                        rejectBtnText="Reject transaction"
                        approveClick={(e) => {
                          if (ensureAll(["APrivateTransaction"]).status) {
                            e?.stopPropagation();
                            handleApproveTransaction(
                              txn?.private_transaction_id,
                            );
                            setApproveRejectbtnClicked((p) => {
                              return {
                                ...p,
                                [txn?.private_transaction_id]: "approve",
                              };
                            });
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "APrivateTransaction",
                              },
                            });
                          }
                        }}
                        rejectClick={() => {
                          if (
                            ensureAll(["APrivateTransaction"]).status &&
                            !isLoadingApprove
                          ) {
                            setApproveRejectbtnClicked((p) => {
                              return {
                                ...p,
                                [txn?.private_transaction_id]: "reject",
                              };
                            });
                            handleDeclinePopup(txn?.private_transaction_id);
                          }
                        }}
                        overlay1Text={
                          txn?.request_status === "pendingOne"
                            ? "Approval pending"
                            : txn?.request_status === "rejected"
                              ? "Approval rejected"
                              : txn?.request_status === "error"
                                ? "Failed to take action"
                                : ""
                        }
                        overlay1Subtext={
                          txn?.request_status === "pendingOne"
                            ? "This transaction has been approved by you and requires another user's approval."
                            : txn?.request_status === "error"
                              ? "An error occurred while taking action on this transaction."
                              : ""
                        }
                        overlay1Icon={
                          txn?.request_status === "pendingOne"
                            ? PendingIcons
                            : txn?.request_status === "rejected"
                              ? DeclinedRed
                              : txn?.request_status === "error"
                                ? FailedToAction
                                : undefined
                        }
                        overlay1IconColor={
                          txn?.request_status === "pendingOne"
                            ? "var(--pending)"
                            : ""
                        }
                        overlay1Cta2Disabled={""}
                        overlay1Cta2Color="var(--positive-act)"
                        overlay1Cta2Text={""}
                        overlay1Cta2OnClick={""}
                        overlay1CtaText={
                          txn?.request_status === "rejected" ||
                          txn?.request_status === "error" ||
                          txn?.request_status === "pendingOne"
                            ? "View details"
                            : ""
                        }
                        overlay1CtaOnClick={
                          txn?.request_status === "rejected" ||
                          txn?.request_status === "error" ||
                          txn?.request_status === "pendingOne"
                            ? () => {
                                setMoreDetailId(txn?.request_reference_id);
                                openMoreDetailPopup();
                              }
                            : ""
                        }
                        overlay2Text={
                          txn?.request_status === "rejected" ? txn?.reason : ""
                        }
                        overlay2Subtext={
                          txn?.request_status === "rejected"
                            ? "Rejected reason"
                            : ""
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div
              className={`flex flex-col items-center justify-center m-auto  Qsmd:mt-[unset] mt-margin-md h-screen ${
                showInnerSearchBar
                  ? "cursor-pointer-none pointer-events-none overflow-hidden"
                  : ""
              }`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop top-top-base opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              {startDateFilter ||
              endDateFilter ||
              currentCategory ||
              LabelSearchText?.length !==
                GlobalConfiguration.lengthCheckZero ? (
                <div className="flex flex-col gap-gap-md items-center justify-center">
                  <img
                    src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                    alt="No accounts found"
                    className="w-graphic-width-lg h-graphic-square-height-md"
                  />
                  <p className="text-text-primary text-font-sm font-normal">
                    No data found.
                  </p>
                  <div>
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={handleClearParams}
                      enabledTextColor="var(--text-primary)"
                    />
                  </div>
                </div>
              ) : (
                <div className="flex flex-col gap-gap-md items-center justify-center">
                  <img
                    src="https://q2pay.in/new_assets/graphics/no_data/no_pending_transaction.svg"
                    alt="No accounts found"
                    className="w-graphic-width-lg h-graphic-square-height-md"
                  />
                  <p className="text-text-primary text-font-sm font-normal">
                    There are no more transactions that require your approval.
                  </p>
                  <div>
                    <PrimaryButton
                      btnText="Private transaction dashboard"
                      handleFunction={() =>
                        navigate("/private_transaction_dashboard")
                      }
                      btnType="button"
                      isDisabled={false}
                      enabledTextColor="var(--text-primary)"
                      disabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      fullWidthRequired={false}
                      inActiveVariantNeeded={false}
                      isLoaderNeeded={false}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PrivateTxnSingleApproval;
